import { Component, OnInit } from "@angular/core";

@Component({
    selector: "app-recurring-payment-declined",
    templateUrl: "./recurring-payment-declined.component.html",
    styleUrls: ["./recurring-payment-declined.component.scss"],
    standalone: false
})
export class RecurringPaymentDeclinedComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
